"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _recompose = require("recompose");

var _Query = require("../../Query");

var _QuickSearchQuery = require("./QuickSearchQuery");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var nestedField = function nestedField(_ref) {
  var field = _ref.field,
      nestedFields = _ref.nestedFields;
  return nestedFields.find(function (x) {
    return x.field === field.field.split('.').slice(0, -1).join('.');
  });
};

var enhance = (0, _recompose.compose)((0, _Query.withQuery)(function (_ref2) {
  var index = _ref2.index,
      projectId = _ref2.projectId;
  return {
    projectId: projectId,
    key: 'extendedFields',
    query: "\n      query ".concat((0, _lodash.capitalize)(index), "ExtendedQuery {\n        ").concat(index, " {\n          extended\n          columnsState {\n            state {\n              columns {\n                field\n                query\n                jsonPath\n              }\n            }\n          }\n        }\n      }\n    ")
  };
}), (0, _recompose.withProps)(function (_ref3) {
  var _data$index, _data$index$extended, _data$index2, _data$index2$extended, _data$index2$extended2, _data$index2$extended3, _data$index2$extended4, _data$index4, _data$index4$columnsS, _data$index5, _data$index5$extended, _data$index5$extended2;

  var index = _ref3.index,
      whitelist = _ref3.whitelist,
      _ref3$extendedFields = _ref3.extendedFields,
      data = _ref3$extendedFields.data,
      loading = _ref3$extendedFields.loading,
      error = _ref3$extendedFields.error,
      _ref3$nestedFields = _ref3.nestedFields,
      nestedFields = _ref3$nestedFields === void 0 ? data === null || data === void 0 ? void 0 : (_data$index = data[index]) === null || _data$index === void 0 ? void 0 : (_data$index$extended = _data$index.extended) === null || _data$index$extended === void 0 ? void 0 : _data$index$extended.filter(function (x) {
    return x.type === 'nested';
  }) : _ref3$nestedFields,
      _ref3$quickSearchFiel = _ref3.quickSearchFields,
      quickSearchFields = _ref3$quickSearchFiel === void 0 ? (data === null || data === void 0 ? void 0 : (_data$index2 = data[index]) === null || _data$index2 === void 0 ? void 0 : (_data$index2$extended = _data$index2.extended) === null || _data$index2$extended === void 0 ? void 0 : (_data$index2$extended2 = _data$index2$extended.filter(function (x) {
    return x.quickSearchEnabled;
  })) === null || _data$index2$extended2 === void 0 ? void 0 : (_data$index2$extended3 = _data$index2$extended2.filter(function (x) {
    var _ref4 = //defaults to "" because a root field's parent would evaluate to such
    nestedField({
      nestedFields: nestedFields,
      field: x
    }) || {},
        _ref4$field = _ref4.field,
        parentField = _ref4$field === void 0 ? '' : _ref4$field;

    return whitelist ? whitelist.includes(parentField) : true;
  })) === null || _data$index2$extended3 === void 0 ? void 0 : (_data$index2$extended4 = _data$index2$extended3.map(function (_ref5) {
    var _data$index3, _data$index3$columnsS;

    var field = _ref5.field;
    return (0, _QuickSearchQuery.decorateFieldWithColumnsState)({
      columnsState: data === null || data === void 0 ? void 0 : (_data$index3 = data[index]) === null || _data$index3 === void 0 ? void 0 : (_data$index3$columnsS = _data$index3.columnsState) === null || _data$index3$columnsS === void 0 ? void 0 : _data$index3$columnsS.state,
      field: field
    });
  })) === null || _data$index2$extended4 === void 0 ? void 0 : _data$index2$extended4.map(function (x) {
    var _nestedField;

    return _objectSpread(_objectSpread({}, x), {}, {
      entityName: ((_nestedField = nestedField({
        field: x,
        nestedFields: nestedFields
      })) === null || _nestedField === void 0 ? void 0 : _nestedField.displayName) || index
    });
  })) || [] : _ref3$quickSearchFiel;
  return {
    quickSearchFields: quickSearchFields,
    quickSearchEntities: (0, _lodash.uniq)(quickSearchFields.map(function (x) {
      return x.entityName;
    })),
    primaryKeyField: (0, _QuickSearchQuery.decorateFieldWithColumnsState)({
      columnsState: data === null || data === void 0 ? void 0 : (_data$index4 = data[index]) === null || _data$index4 === void 0 ? void 0 : (_data$index4$columnsS = _data$index4.columnsState) === null || _data$index4$columnsS === void 0 ? void 0 : _data$index4$columnsS.state,
      field: data === null || data === void 0 ? void 0 : (_data$index5 = data[index]) === null || _data$index5 === void 0 ? void 0 : (_data$index5$extended = _data$index5.extended) === null || _data$index5$extended === void 0 ? void 0 : (_data$index5$extended2 = _data$index5$extended.find(function (x) {
        return x.primaryKey;
      })) === null || _data$index5$extended2 === void 0 ? void 0 : _data$index5$extended2.field
    }),
    nestedFields: nestedFields
  };
}));

var QuickSearchFieldsQuery = function QuickSearchFieldsQuery(_ref6) {
  var render = _ref6.render,
      quickSearchFields = _ref6.quickSearchFields,
      quickSearchEntities = _ref6.quickSearchEntities,
      primaryKeyField = _ref6.primaryKeyField;
  return render({
    quickSearchFields: quickSearchFields,
    quickSearchEntities: quickSearchEntities,
    primaryKeyField: primaryKeyField,
    enabled: primaryKeyField && (quickSearchFields === null || quickSearchFields === void 0 ? void 0 : quickSearchFields.length)
  });
};

var _default = enhance(QuickSearchFieldsQuery);

exports["default"] = _default;